'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.global_event', {
    url: '/global_event',
    template: '<oem-global-event></oem-global-event>'
  });
}



// WEBPACK FOOTER //
// ./public/dev/app/oem/global_event/global_event.routes.js